import {isAdmin} from "../access/isAdmin";
import {isAdminOrSelf} from "../access/isAdminOrSelf";
import {isLoggedIn} from "../access/isLoggedIn";

export type {AuthorizationPluginConfig} from '../types.js'
export {isAdmin}
export {isAdminOrSelf}
export {isLoggedIn}
